// import moment from "moment";

export default class Atividade {

  constructor(
    IdEmpresa = 1,
    IdAtividade = null,
    Descricao = '', 
    // DataEmissao = moment.utc().toISOString(),
    DataEmissao = new Date(),
    // DataPrevisao = moment().format('YYYY-MM-DD').toString(),
    DataPrevisao = new Date(),
    IdResponsavel = JSON.parse(localStorage.getItem('user')).IdColaborador || null, 
    Responsavel = JSON.parse(localStorage.getItem('user')).Colaborador || '',
    IdTipoAtividade = 3, 
    TipoAtividade = 'PROJETO',
    IdPrioridade = 1,
    Prioridade = 'NORMAL',
    IdSituacao = 71, 
    Situacao = 'INICIO',
    Progresso = 0,
    Observacoes = '',
    Status = '',
    Duracao = new Date(1970, 0, 1, 0, 0, 0),
    IdWorkflow,
    Workflow,
    IdModeloAtividade,
    ModeloAtividade
  ) {

    this.IdEmpresa = IdEmpresa;
    this.IdAtividade = IdAtividade;
    this.Descricao = Descricao;
    this.DataEmissao = DataEmissao;
    this.DataPrevisao = DataPrevisao;
    this.IdResponsavel = IdResponsavel;
    this.Responsavel = Responsavel;
    this.IdTipoAtividade = IdTipoAtividade;
    this.TipoAtividade = TipoAtividade;
    this.IdPrioridade = IdPrioridade;
    this.Prioridade = Prioridade;
    this.IdSituacao = IdSituacao;
    this.Situacao = Situacao;
    this.Progresso = Progresso;
    this.Observacoes = Observacoes;
    this.Status = Status;
    this.Duracao = Duracao
    this.IdWorkflow = IdWorkflow;
    this.Workflow = Workflow;
    this.IdModeloAtividade = IdModeloAtividade;
    this.ModeloAtividade = ModeloAtividade;
  }
  
}